import React from "react";
import { Link } from "react-router-dom";
import { Col, Row } from 'antd';
import "./style.scss";

const Demo: React.FC = () => {
  return (
    <div className="demos-layout">
      <div className="layout">
        <div className="inner-layout">
          <div className="demo flex space-between">
            <img className="top-left square" alt='' src='/images/footer/square.svg' />
            <img className="top-right square" alt='' src='/images/footer/square.svg' />
            <img className="bottom-left square" alt='' src='/images/footer/square.svg' />
            <img className="bottom-right square" alt='' src='/images/footer/square.svg' />
            <div className="left">
              <h1>Ready to explore the</h1>
              <h1 className="gradient">future of DeFi + AI?</h1>
              {/* <div className="launch"><span>Try DefAi Now</span><img alt='' src="images/home/main-banner/right.svg" /></div> */}
            </div>
            <div className="right">
              <video
                className="banner"
                playsInline
                webkit-playsinline
                autoPlay
                muted
                loop
              >
                <source src="/main-banner-3.mp4" type="video/mp4" />
                {/* <source src="/pic.webm" type="video/webm" /> */}
              </video>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Demo;
